import axios from "axios";
import { store } from "state/store";

/**
 * Tableau de suivi A/B test front B2C — lecture seule, hors middleware Redux
 * (un seul GET agrégé, pas d'état partagé entre vues).
 * Endpoint : GET /api/v2/admin/store/abtest-funnel.json (lemoulinapi).
 */

const baseUrl = process.env.REACT_APP_LEMOULIN_API_URL;
const apiKey = process.env.REACT_APP_LEMOULIN_API_KEY;

function authHeaders(extra = {}) {
  const token = store.getState().session?.token || window.localStorage.getItem("token");
  return {
    Accept: "application/json",
    ...(token ? { "X-Custom-Authorization": `Bearer ${token}` } : {}),
    ...extra,
  };
}

/**
 * Funnel agrégé par version.
 * @param {Object} params { from, to } (période « au réel ») OU { deliveryDate }
 * @returns {Promise} resolve avec { mode, versions: { 1: {...}, 2: {...} } }
 *   (l'API enveloppe toutes ses réponses dans { code, result } — on déballe ici)
 */
export function getFunnel(params) {
  const query = new URLSearchParams({ apiKey, ...params }).toString();
  return axios
    .get(`${baseUrl}/v2/admin/store/abtest-funnel.json?${query}`, { headers: authHeaders() })
    .then((res) => res.data.result);
}
